import React from 'react'

export default function RightCircleIcon(props) {


    return (
        <>
            <svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="17.5013" cy="16.6863" rx="17.0833" ry="16.2698" fill="#35F29A" />
                <path d="M14.2251 19.8758L10.2403 16.1255L8.5293 17.7359L14.2251 23.0966L25.9712 12.0414L24.2602 10.431L14.2251 19.8758Z" fill="white" />
            </svg>

        </>
    )
}
